var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-item',{attrs:{"lines":"none"}},[_c('ion-label',[_vm._v(_vm._s(_vm.label))]),_c('ion-checkbox',{attrs:{"checked":_vm.checked},on:{"ionChange":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }